<script setup lang="ts">
import type { Topic } from '~~/src/types/topic'

const props = defineProps<{
  topic?: Topic
  isActive: boolean
  isBubbles?: boolean
  useAsFilter?: boolean
}>()

const emits = defineEmits<{
  (event: 'click', value?: Topic): void
}>()

const onClick = (topic: Topic) => {
  if (props.useAsFilter) {
    emits('click', topic)
    return false
  }

  return true
}

const url = computed(() => props.topic ? `/topic/${props.topic.url}` : '/')
</script>

<template>
  <NuxtLink
    :to="!useAsFilter ? url : undefined"
    class="flex items-center justify-center px-3 transition-colors text-darkGray cursor-pointer"
    :class="[
      isBubbles ? 'h-7 bg-grayLighter rounded-full hover:bg-softGray' : 'h-12 hover:text-softBlack',
      isActive && isBubbles && 'bg-softGray text-darkerGray',
    ]"
    @click.prevent="() => onClick(topic)"
  >
    <TextV2
      class="font-bold"
      :class="[
        isActive && !isBubbles && 'text-softBlack',
        isActive && isBubbles && 'text-darkerGray',
        isBubbles ? 'body-12' : 'body-14',
      ]"
    >
      {{ topic?.name || 'All' }}
    </TextV2>
  </NuxtLink>
</template>
